import anime from 'animejs';
const YTPlayer = require('yt-player');

/* custom imports */
import { hideTitle, revealController, revealTitle, revealVideo } from '.././animation/video.js';

/** ----------------------------------------
    Video
 ---------------------------------------- */

/**
 * This class will handle a background
 * video using a Youtube video.
 */

export class Video {

    /**
     * @init            calls the init method
     */

    constructor(element) {
        this.active = false;
        this.config = {};
        this.duration = '';
        this.element = element;
        this.interval = '';
        this.player = {};
        setTimeout(() => this.init(), 1000);
    }

    /** ----------------------------------------
        Convert Minutes
     ---------------------------------------- */

    convertToMinutes(time) {
        let minutes = Math.floor(time / 60);
        let seconds = Math.floor((time / 60 - minutes) * 60);
        let convert = seconds < 10 ? '0' : '';

        return `${minutes}:${convert + seconds} min`
    }

    /** ----------------------------------------
        Toggle State
     ---------------------------------------- */

    toggleState(element, active, inactive) {
        let state = element;

        state.classList.add(active);
        state.classList.remove(inactive)

        this.progressBarAnimation();
    }

    /** ----------------------------------------
        Merge Settings
     ---------------------------------------- */

    mergeSettings(obj1, obj2) {
        return Object.assign(obj1, obj2);
    }

    /** ----------------------------------------
        Set Configuration
     ---------------------------------------- */

    setConfig(video) {
        let container = video.parentNode;

        this.config['id'] = container.dataset.video;
        this.config['start'] = parseInt(container.dataset.start);
        this.config['end'] = parseInt( container.dataset.end);
    }

    /** ----------------------------------------
        Set YouTube
     ---------------------------------------- */

    setYoutube() {
        this.player = new YTPlayer(this.element, {
            annotations: false,
            autoplay: false,
            captions: false,
            controls: false,
            fullscreen: false,
            keyboard: false,
            info: false,
            related: false
        });
    }

    /** ----------------------------------------
        Set Player Events
     ---------------------------------------- */

    setEvents() {
        let _this = this;

        this.player.on('playing', () => {
            _this.setDuration();
            _this.revealVideo();
        });

        this.player.on('cued', () => {
            _this.startVideo();
        });

        this.player.on('ended', () => {
            _this.clear();
            _this.player.seek(this.config.start);
        });
    }

    /** ----------------------------------------
        Video Duration
     ---------------------------------------- */

    setDuration() {
        this.duration = this.player.getDuration();

        let time = document.querySelector('.header__time');
        let format = this.convertToMinutes(this.duration);

        time.innerHTML = `(${format})`;
    }

    checkDuration() {
        this.interval = setInterval(() => {
            let duration = this.player.getCurrentTime().toFixed(2);

            if(duration > this.config.end)
                this.replayVideo();
        }, 100);
    }

    /** ----------------------------------------
        Video Reveal
     ---------------------------------------- */

    revealVideo() {
        if(this.active)
            return;

        setTimeout(() => {
            this.checkDuration();
            this.watchVideo();
            this.revealAnimation();

            this.player.seek(this.config.start);

            this.active = true;
        }, 1000);
    }

    /** ----------------------------------------
        Reveal Animation
     ---------------------------------------- */

    revealAnimation() {
        let _this = this;

        let video = document.querySelector(this.element).parentNode;
        let animation = this.mergeSettings({ targets: video }, revealVideo);

        let reveal = anime(animation);

        reveal.finished.then(() => {
            let controller = document.querySelectorAll('.header__controller > *');
            let animation = _this.mergeSettings({ targets: controller }, revealController);

            anime(animation);
        });
    }

    /** ----------------------------------------
        Video Start
     ---------------------------------------- */

    startVideo() {
        this.player.play(this.config.start);
        this.player.setVolume(0);
    }

    /** ----------------------------------------
        Video Replay
     ---------------------------------------- */

    replayVideo() {
        this.player.seek(this.config.start);
    }

    /** ----------------------------------------
        Watch Video
     ---------------------------------------- */

    watchVideo() {
        let state = document.querySelector('.header__controller');

        state.addEventListener('click', () => {
            state.classList.toggle('is-clicked');
            state.classList.contains('is-paused') ? this.play(state) : this.pause(state);
        });
    }

    play(state) {
        this.clear();
        this.toggleState(state, 'is-playing', 'is-paused');
        this.hideTitle();

        this.player.seek(0);
        this.player.setVolume(80);
    }

    pause(state) {
        this.checkDuration();
        this.toggleState(state, 'is-paused', 'is-playing');
        this.revealTitle();

        this.player.seek(this.config.start);
        this.player.setVolume(0);
    }

    clear() {
        clearInterval(this.interval);
    }

    progress() {
        let progress = document.querySelector('.header__progress');

        setInterval(() => {
            let passed = this.player.getCurrentTime() / this.duration;
            progress.style.width = `${passed * 100}%`;
        }, 100);
    }

    /** ----------------------------------------
        Reveal Title
     ---------------------------------------- */

    revealTitle() {
        let text = document.querySelectorAll('.header__container > *');
        let animation = this.mergeSettings({ targets: text }, revealTitle);

        anime(animation);
    }

    /** ----------------------------------------
        Hide Title
     ---------------------------------------- */

    hideTitle() {
        let text = document.querySelectorAll('.header__container > *');
        let animation = this.mergeSettings({ targets: text }, hideTitle);

        anime(animation);
    }

    /** ----------------------------------------
        Progress Animation
     ---------------------------------------- */

    progressBarAnimation() {
        let progress = document.querySelector('.header__bar');
        progress.classList.toggle('is-active');
    }

    /** ----------------------------------------
        Scale Video
     ---------------------------------------- */

    scaleVideo() {
        let video = document.querySelector(this.element);
        video.classList.toggle('is-active');
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */

    init() {
        let video = document.querySelector(this.element);

        if(!video)
            return;

        let header = document.querySelector('.header__video');
        let start = header.dataset.start;
        let end = header.dataset.end;

        if((end - start) < 3)
            return;

        this.setConfig(video);
        this.setYoutube();
        this.progress();
    }

}